import React from 'react';
import { useSelector } from "react-redux";

export default function Evisa() {
    const lang = useSelector((state) => state.mainSlice.lang);
    return (
        <div className='evisa-page pt-5'>
            <div className="container">
                <div className="row">
                    <div className="col-lg-6 col-md-6 col-sm-12 col-xs-12 m-auto">
                        <div className="d-flex justify-content-center flex-column align-items-center">
                            <h1 className='text-center w-100' style={{ fontSize: '60px' }}>🔧</h1>
                            <h4 style={{ fontWeight: "800" }}>
                                {
                                    lang === "ru"
                                        ?
                                        "Сервис проверки электронных виз"
                                        :
                                        lang === "tm"
                                            ?
                                            "Elektron wizany barlamak hyzmaty"
                                            :
                                            "Visa verification service"
                                }
                            </h4>
                            <div className='evisa-alert alert alert-warning mt-2 w-100 text-center' role="alert">
                                {
                                    lang === "ru"
                                        ?
                                        "⚠️ Сервис проверки статуса визы онлайн находится в разработке"
                                        :
                                        lang === "tm"
                                            ?
                                            "⚠️ Onlaýn elektron wizanyň ýagdaýyny barlamak hyzmaty işlenilýär."
                                            :
                                            "⚠️ The online e-visa status verification service is under development."
                                }
                            </div>
                            <div className='evisa-content alert alert-info mt-2 w-100 d-none' role="alert">
                                <p className='iinfo'>
                                    {
                                        lang === "ru"
                                            ?
                                            "ℹ️ Важная информация"
                                            :
                                            lang === "tm"
                                                ?
                                                "ℹ️ Wajyp maglumat"
                                                :
                                                "ℹ️ Important information"
                                    }
                                </p>
                                <p><b>
                                    {
                                        lang === "ru"
                                            ?
                                            "Электронные визы являются приглашением и позволяют:"
                                            :
                                            lang === "tm"
                                                ?
                                                "Elektron wizalar çagyryş bolup, şulary amala aşyrmaga mümkinçilik berýär:"
                                                :
                                                "E-visas are invitations and allow you to:"
                                    }
                                </b></p>
                                <ul>
                                    <li>
                                        {
                                            lang === "ru"
                                                ?
                                                "Прилететь в страну назначения"
                                                :
                                                lang === "tm"
                                                    ?
                                                    "Ýurda gelmek"
                                                    :
                                                    "Arrive at the destination"
                                        }
                                    </li>
                                    <li>
                                        {
                                            lang === "ru"
                                                ?
                                                "Приехать на пограничный контроль"
                                                :
                                                lang === "tm"
                                                    ?
                                                    "Serheе gözegçilik nokadyna gelmek"
                                                    :
                                                    "Arrive at the border control point"
                                        }
                                    </li>
                                </ul>
                                <p><b>
                                    {
                                        lang === "ru"
                                            ?
                                            "Пограничный контроль имеет всю необходимую информацию для проверки вашей электронной визы."
                                            :
                                            lang === "tm"
                                                ?
                                                "Serheе gözegçilik nokady elektron wizanyňyzy barlamak üçin ähli zerur maglumatlara eýe."
                                                :
                                                "The border control has all the necessary information to verify your e-visa."
                                    }
                                </b></p>
                                <p>
                                    {
                                        lang === "ru"
                                            ?
                                            "Предьявите вашу электронную визу офицеру пограничного контроля при прохождении паспортного контроля."
                                            :
                                            lang === "tm"
                                                ?
                                                "Elektron wizanyňyzy serheş gözegçilik nokadynyň ofiserine pasport gözegçiligi wagtynda görkezmeli."
                                                :
                                                "Present your e-visa to the border control officer when passing through passport control."
                                    }
                                </p>
                            </div>
                        </div>
                        <div className='divider w-100 my-3 mb-4'></div>
                        <p className='text-center text-muted mb-5'>
                            {
                                lang === "ru"
                                    ?
                                    "Сервис проверки статуса визы онлайн скоро будет доступен."
                                    :
                                    lang === "tm"
                                        ?
                                        "Elektron wiza ýagdaýyny barlamak hyzmaty ýakyn wagtda elýeterli bolar."
                                        :
                                        "The online visa status checking service will be available soon."
                            }
                        </p>
                    </div>
                </div>
            </div>
        </div>
    )
}
